.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-3);
}

.titleInput,
.titleArea {
	width: 100%;
	border: none;
	background: none;
	padding: var(--space-1) 0;
	font: inherit;
	font-size: 1.0625rem;
	color: var(--ink);
	outline: none;
}

.titleArea {
	resize: none;
	line-height: 1.4;
}

.controls {
	display: flex;
	align-items: center;
	gap: var(--space-2);
}

.options {
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	gap: var(--space-2);
	flex-wrap: wrap;
}

/* Pill control for category / assignees. */
.chip {
	display: inline-flex;
	align-items: center;
	gap: var(--space-1);
	background: var(--surface-input);
	border: 1px solid var(--border);
	border-radius: var(--radius-md);
	color: var(--ink);
	font: inherit;
	font-size: 0.8125rem;
	padding: var(--space-1) var(--space-3);
	cursor: pointer;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.chip:hover {
	border-color: var(--ink-muted);
}

.catDot {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	flex: none;
}

/* Square icon-only controls (priority, expand). */
.iconChip {
	border: none;
	background: transparent;
	width: 32px;
	height: 32px;
	border-radius: var(--radius-sm);
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	color: var(--ink-muted);
	flex: none;
}

.iconChip:hover {
	background: var(--surface-input);
}

/* Circular submit. */
.submit {
	flex: none;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	border: none;
	background: var(--accent-sage);
	color: #fff;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	justify-content: center;
}

.submit:disabled {
	opacity: 0.4;
	cursor: not-allowed;
}
